var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('codemirror',{ref:"codemirror",staticClass:"codemirror",attrs:{"options":_vm.options},on:{"cursorActivity":_vm.onCmCursorActivity,"ready":_vm.onCmReady,"focus":_vm.onCmFocus,"blur":_vm.onCmBlur}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }